module.exports = __webpack_public_path__ + "static/media/Jorge.0f879acd.png";